import "core-js/modules/es6.object.assign";
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import 'react-dom';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-27cf4a5a.js';
import './chunk-23007274.js';
import { a as OverlayContainer, b as OverlayToggle, c as OverlayShow, d as OverlayHide } from './chunk-12f4f9f4.js';
var Overlay = styled(Hidden).withConfig({
  displayName: "Overlay",
  componentId: "tgx0ep-0"
})(["position:fixed;z-index:19900410;left:50%;top:50%;", ";"], theme("Overlay"));
Overlay.defaultProps = {
  role: "dialog",
  "aria-modal": true,
  hideOnEsc: true,
  translateX: "-50%",
  translateY: "-50%",
  defaultSlide: "top",
  opaque: true,
  palette: "background",
  tone: -1
};
var Overlay$1 = as("div")(Overlay);
var Overlay$2 = Object.assign(Overlay$1, {
  Container: OverlayContainer,
  Toggle: OverlayToggle,
  Show: OverlayShow,
  Hide: OverlayHide
});
export default Overlay$2;